function dragScroll(scrollableElement: HTMLElement) {
  if (!scrollableElement) throw new Error('Scrollable element is required.')
  if (scrollableElement.dataset.dragScrollEnabled === 'true') return () => {}

  let isDragging = false
  let startX = 0
  let startScrollLeft = 0

  const onMouseDown = (e: MouseEvent) => {
    if (e.button !== 0) return

    // Prevent dragging if inside the DivTable header.
    const target = e.target as HTMLElement
    if (
      target.closest(
        '.div-grid-header, button, a, input, textarea, select, option, [role="button"], .v-input, .v-field, .v-select, .v-text-field, .v-autocomplete, .v-btn',
      )
    ) {
      return
    }

    isDragging = true
    startX = e.clientX
    startScrollLeft = scrollableElement.scrollLeft
    scrollableElement.style.cursor = 'grabbing'
    scrollableElement.style.userSelect = 'none'

    window.addEventListener('mousemove', onMouseMove)
    window.addEventListener('mouseup', onMouseUp)
  }

  const onMouseMove = (e: MouseEvent) => {
    if (!isDragging) return
    const deltaX = e.clientX - startX

    scrollableElement.scrollLeft = startScrollLeft - deltaX * 1.5
    e.preventDefault()
  }

  const onMouseUp = () => {
    isDragging = false
    scrollableElement.style.cursor = 'grab'
    scrollableElement.style.userSelect = ''

    window.removeEventListener('mousemove', onMouseMove)
    window.removeEventListener('mouseup', onMouseUp)
  }

  scrollableElement.addEventListener('mousedown', onMouseDown)
  scrollableElement.addEventListener('mouseleave', onMouseUp)


  scrollableElement.style.cursor = 'grab'
  scrollableElement.dataset.dragScrollEnabled = 'true'

  return () => {
    onMouseUp()
    scrollableElement.removeEventListener('mousedown', onMouseDown)
    scrollableElement.removeEventListener('mouseleave', onMouseUp)
    scrollableElement.style.cursor = ''
    scrollableElement.style.userSelect = ''
    delete scrollableElement.dataset.dragScrollEnabled
  }
}

export const enableDivTableDragScroll = (tableWrapperClassName: string) => {
  const tableWrappers = document.getElementsByClassName(tableWrapperClassName)

  if (!tableWrappers.length) {
    console.error('No table wrappers found with the class name:', tableWrapperClassName)
    return () => {}
  }

  const cleanupFns: Array<() => void> = []

  for (let i = 0; i < tableWrappers.length; i++) {
    const wrapper = tableWrappers[i] as HTMLElement
    const scrollableElement = wrapper.querySelector('.div-table-wrapper') as HTMLElement

    if (!scrollableElement) {
      console.error('No scrollable element (div-table-wrapper) found inside the wrapper:', wrapper)
      continue
    }

    cleanupFns.push(dragScroll(scrollableElement))
  }

  return () => {
    cleanupFns.forEach(cleanup => cleanup())
  }
}
